// «Marcar entregado»: al terminar, bien o mal, relee la lista para pintar el estado real.
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { portalRefundsClient } from '@/api/services/retail-wizard/portalRefunds.client';
import { STORE_REFUNDS_KEY } from './useStoreRefunds';

export function useDeliverRefund() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (sessionId: string) => portalRefundsClient.deliver(sessionId),
        onSettled: () => qc.invalidateQueries({ queryKey: STORE_REFUNDS_KEY }),
    });
}
